export default {
    name: 'Name',
    surname: 'Surname',
    contact: 'Contact',
    group: 'Group',
    department: 'Department',
    status: 'Status',
    line: 'Line',
    createNewEmployee: 'Create New Employee',
    updateEmployee: 'Edit Employee Profile',
    profile: 'Profile',
    citizenId: 'Citizen ID/Passport ID',
    employeeNo: 'Employee NO',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    dateOfBirth: 'Date of Birth',
    statusStart: 'Start Date',
    statusEnd: 'End Date',
    branch: 'Branch',
    role: 'Role',
    email: 'Email',
    phoneNumber: 'Phone Number',
    employment: 'Employment',
    fullTime: 'Full Time',
    probation: 'Probation',
    save: 'Save',
    cancel: 'Cancel',
    msgImageSize: 'Image size must be between 25KB and 200KB',
    msgErrorImageSize: 'Image size can not be less than 25KB or more than 200KB',
    msgError: 'Error Message',
    congratulation: 'Congratulation',
    warning: 'Warning',
    error: 'Error',
    msgRequiredField: 'This field is required',
    msgExceededField: 'This field is exceeded 255 characters',
    msgRequiredEmail: 'E-mail is required',
    msgInvalidEmailFormat: 'Invalid e-mail format',
    msgExceededEmail: 'E-mail is exceeded 255 characters',
    msgIncorrectPhoneNumber: 'Incorrect Phone Number',
    msgImageSizeZkt: 'Image size must be between 50KB and 400KB',
    msgErrorImageSizeZkt: 'Image size can not be less than 50KB or more than 400KB',
    employee_dangerzone_job: 'Job',
    danger_zone_time_min: 'Time in Danger Zone (minutes)',
    card_sn: 'Card Serial Number'
}
